import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AutoCompleteCombo, Input, Label, ValidationMessage, FormattedInput } from '../form';
import { useStyles } from './prefill_verify_address_styles';

const _PrefillAddressVerification = (props) => {
    const classes = useStyles();
    const {
        setValue,
        postcode,
        lockedOut,
        invalidAdress,
        incompleteEntry,
        addressLabel
    } = props;

    return (
        <div className={classes.hnc_prefill_address_wrapper}>
            <div className={classes.postcode_wrapper}>
                <Label
                    labelKey={'label'}
                    variant={'default'}
                    schema={{
                        label: 'Postcode'
                    }}
                />
                <FormattedInput
                    stateKey={'vertical.quote'}
                    backendIdentifier={'property.address.postcode'}
                    identifier={'prefill.propertyPostcode'}
                    schema={{
                        identifier: 'prefill.propertyPostcode',
                        stateKey: 'vertical.quote',
                        backendIdentifier: 'property.address.postcode',
                        label: 'Postcode',
                        maskInRecording: true,
                        privateData: true,
                        field: {
                            type: 'formatted',
                            inputType: 'postcode',
                            placeholder: 'Postcode',
                            metaType: 'tel',
                            maxlength: '4',
                            minlength: '4'
                        },
                        rules: [
                            {
                                controls: 'validation',
                                props: {
                                    stateKey: 'vertical.quote.form.property.address.postcode',
                                    errorMessages: {
                                        isSupplied: 'Please enter a valid postcode',
                                        validPostCode: 'Please enter a valid postcode'
                                    }
                                },
                                trigger: 'onBlur'
                            }
                        ]
                    }}
                    dispatch={(event) => { setValue(event); }}
                    touched
                    rules={{
                        validation:
                        {
                            result: !(!!invalidAdress || (incompleteEntry && !postcode))
                        },
                        disabled:
                        {
                            result: lockedOut
                        }
                    }}
                />
                {incompleteEntry && !postcode
                    ? (
                        <ValidationMessage
                            manualControl
                            manualVisible
                            manualErrorMessage={'Please enter a valid postcode'}
                            rules={{
                                validation: true,
                                position: 'left'
                            }}
                        />
                    )
                    : null}
            </div>
            <div className={classes.address_wrapper}>
                <Label
                    labelKey={'label'}
                    variant={'default'}
                    schema={{
                        label: 'Address'
                    }}
                />
                <AutoCompleteCombo
                    schema={{
                        identifier: 'prefill.propertyAddressLabel',
                        label: 'Address',
                        stateKey: 'vertical.quote',
                        field: {
                            type: 'autoCompleteCombo',
                            placeholder: 'e.g. 5/20 Sample Street',
                            debounceTime: 500,
                            addonWidth: 'default',
                            autoFocus: true,
                            noResultsMessage: 'Sorry, we couldn\'t find your address. Try starting a new quote',
                            dontReset: [
                                'postcode'
                            ]
                        },
                        config: {
                            minChars: 2,
                            minCharsType: 'alpha',
                            labelTemplate: '{text}',
                            valueTemplate: '{text}',
                            helpers: {
                                triggerManualEntry: 'helpers.unableToFindAddress_property'
                            },
                            stateKeyMap: {
                                postcode: 'postCode',
                                suburb: 'suburbName',
                                streetNumber: 'houseNoSel',
                                buildingName: 'buildingName',
                                unitNumber: 'unitSel',
                                gnafId: 'gnafId',
                                streetName: 'streetName',
                                state: 'state',
                                unitType: 'unitType'
                            },
                            targetIdentifier: 'property.address'
                        },
                        api: {
                            onChange: {
                                baseUrlName: 'addressServiceBaseUrl',
                                url: 'streetsuburb',
                                extraPayload: {
                                    postCodeOrSuburb: 'property.address.postcode'
                                },
                                type: 'POST',
                                requestPayloadValueName: 'addressLine',
                                requestAction: 'POST_PAYLOAD_ADDRESS',
                                failureType: 'non-fatal'
                            }
                        }
                    }}
                    touched
                    value={''}
                    rules={{
                        validation:
                        {
                            result: !(!!invalidAdress || (incompleteEntry && !addressLabel))
                        },
                        disabled:
                        {
                            result: !postcode || lockedOut
                        }
                    }}
                />
                {incompleteEntry && !addressLabel && !lockedOut
                    ? (
                        <ValidationMessage
                            manualControl
                            manualVisible
                            manualErrorMessage={'Please enter your address then select from the list provided'}
                            rules={{
                                validation: true,
                                position: 'left'
                            }}
                        />
                    )
                    : null}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const postcode = state.getIn(['vertical', 'quote', 'form', 'property', 'address', 'postcode']);
    const addressLabel = state.getIn(['vertical', 'quote', 'form', 'helpers', 'propertyAddressLabel']);
    return { postcode, addressLabel };
};

const mapDispatchToProps = (dispatch) => ({
    setValue: (action) => {
        dispatch(action);
    }
});

_PrefillAddressVerification.propTypes = {
    setValue: PropTypes.func,
    addressLabel: PropTypes.string,
    postcode: PropTypes.string,
    lockedOut: PropTypes.bool,
    invalidAdress: PropTypes.bool,
    incompleteEntry: PropTypes.bool
};

const PrefillAddressVerification = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PrefillAddressVerification);

export { _PrefillAddressVerification, PrefillAddressVerification };
